var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningRoundFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 14 14",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.75 7C0.75 3.54822 3.54822 0.75 7 0.75C10.4518 0.75 13.25 3.54822 13.25 7C13.25 10.4518 10.4518 13.25 7 13.25C3.54822 13.25 0.75 10.4518 0.75 7ZM5.75 7.5C5.75 8.19035 6.30965 8.75 7 8.75C7.69035 8.75 8.25 8.19035 8.25 7.5V3.75C8.25 3.05965 7.69035 2.5 7 2.5C6.30965 2.5 5.75 3.05965 5.75 3.75V7.5ZM7 9C6.17158 9 5.5 9.67155 5.5 10.5C5.5 11.3284 6.17158 12 7 12C7.82842 12 8.5 11.3284 8.5 10.5C8.5 9.67155 7.82842 9 7 9Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningRoundFilled);
export default ForwardRef;